import _classCallCheck from "C:/Users/onlyme/git_ssd/webs/generadoraleatorio.com/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "C:/Users/onlyme/git_ssd/webs/generadoraleatorio.com/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
@license Foswig.js | (c) Glenn Conner. | https://github.com/mrsharpoblunto/foswig.js/blob/master/LICENSE
@format
*/
var MarkovChain = /*#__PURE__*/function () {
  /**
   * order indicates how many previous characters to take into account when picking the next. A lower number represents more random words, whereas a higher number will result in words that match the input words more closely.
   */
  function MarkovChain(order, words) {
    _classCallCheck(this, MarkovChain);

    this.order = order;
    this.duplicates = {
      children: {}
    };
    this.start = {
      character: '',
      neighbors: []
    };
    this.init(words);
  }

  _createClass(MarkovChain, [{
    key: "init",
    value: function init(words) {
      var map = {};

      var _iterator = _createForOfIteratorHelper(words),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var word = _step.value;
          this.addToDuplicatesTrie(word.toLowerCase());
          var previous = this.start;
          var key = '';

          for (var i = 0; i < word.length; ++i) {
            var ch = word[i];
            key += ch;

            if (key.length > this.order) {
              key = key.substr(1);
            }

            var newNode = map[key];

            if (!newNode) {
              newNode = {
                character: ch,
                neighbors: []
              };
              map[key] = newNode;
            }

            previous.neighbors.push(newNode);
            previous = newNode;
          } //link to end node.


          previous.neighbors.push(null);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Adds a word and all its substrings to a duplicates trie to
     * ensure that generated words are never an exact match or substring
     * of a word in the input dictionary. Building a trie allows us
     * to efficiently search for these duplicates later without
     * having to do O(N) comparision checks over the entire dictionary
     */

  }, {
    key: "addToDuplicatesTrie",
    value: function addToDuplicatesTrie(word) {
      if (word.length > 1) {
        this.addToDuplicatesTrie(word.substr(1));
      }

      var currentNode = this.duplicates;

      for (var i = 0; i < word.length; ++i) {
        var childNode = currentNode.children[word[i]];

        if (!childNode) {
          childNode = {
            children: {}
          };
          currentNode.children[word[i]] = childNode;
        }

        currentNode = childNode;
      }
    }
    /**
     * Check to see if a word is a match to any substring in the input
     * dictionary in O(N) time, where N is the number of characters in the
     * word rather than the number of words in the dictionary.
     * @param {string} word The word we want to find out whether it is a
     * duplicate of a substring in the input dictionary.
     */

  }, {
    key: "isDuplicate",
    value: function isDuplicate(word) {
      word = word.toLowerCase();
      var currentNode = this.duplicates;

      for (var i = 0; i < word.length; ++i) {
        var childNode = currentNode.children[word[i]];
        if (!childNode) return false;
        currentNode = childNode;
      }

      return true;
    }
  }, {
    key: "generate",
    value: function generate(_ref) {
      var _ref$minLength = _ref.minLength,
          minLength = _ref$minLength === void 0 ? 0 : _ref$minLength,
          _ref$maxLength = _ref.maxLength,
          maxLength = _ref$maxLength === void 0 ? 0 : _ref$maxLength,
          _ref$allowDuplicates = _ref.allowDuplicates,
          allowDuplicates = _ref$allowDuplicates === void 0 ? true : _ref$allowDuplicates,
          _ref$maxAttempts = _ref.maxAttempts,
          maxAttempts = _ref$maxAttempts === void 0 ? 25 : _ref$maxAttempts,
          _ref$random = _ref.random,
          random = _ref$random === void 0 ? Math.random : _ref$random;
      var word;
      var repeat;
      var attempts = 0;

      do {
        repeat = false;
        var nextNodeIndex = Math.floor(random() * this.start.neighbors.length);
        var currentNode = this.start.neighbors[nextNodeIndex];
        word = '';

        while (currentNode && (maxLength <= 0 || word.length <= maxLength)) {
          word += currentNode.character;
          nextNodeIndex = Math.floor(random() * currentNode.neighbors.length);
          currentNode = currentNode.neighbors[nextNodeIndex];
        }

        if (maxLength > 0 && word.length > maxLength || word.length < minLength) {
          repeat = true;
        }
      } while ( // we don't want to output any exact replicas from the input dictionary
      (repeat || !allowDuplicates && this.isDuplicate(word)) && (maxAttempts <= 0 || ++attempts < maxAttempts));

      if (maxAttempts > 0 && attempts >= maxAttempts) {
        throw new Error('Unable to generate a word with the given parameters after ' + attempts + ' attempts');
      }

      return word;
    }
  }]);

  return MarkovChain;
}();

export { MarkovChain as default };